import React, { forwardRef } from 'react';
import { DoubleSide, Group } from 'three';

interface IParentProps {
    handedness: XRHandedness;
    activeSelectHand: XRHandedness[];
    visible: boolean;
}

const Cursor = forwardRef<Group, IParentProps>(({ handedness, activeSelectHand, visible }, ref) => {
   const isActive = activeSelectHand.includes(handedness);
    
    return (
        <group ref={ref} name={`cursor-group-${handedness}`} renderOrder={Number.POSITIVE_INFINITY} visible={visible} scale={[0.2, 0.2, 0.2]} >
            <mesh>
                <ringGeometry args={[isActive ? 0.19 / 2 : 0.21 / 2, isActive ? 0.11 / 2 : 0.13 / 2, 50 / 2]} />
                <meshBasicMaterial color={'light-grey'} side={DoubleSide} depthWrite={false} depthTest={false} transparent/>
            </mesh>
            <mesh position={[0, 0, 0.001]}>
                <ringGeometry args={[isActive ? 0.18 / 2 : 0.2 / 2, isActive ? 0.12 / 2 : 0.14 / 2, 50 / 2]} />
                <meshBasicMaterial color={isActive ? "rgb(5, 213, 250)" : "rgb(153, 252, 255)"} side={DoubleSide} depthWrite={false} depthTest={false} transparent/>
            </mesh>
        </group>
    ); 
})

export default Cursor;